/**
 * @file Helper functions for getting strings from specific data
 * @author Max van Loosbroek
 */

import {
  DetailedRobot,
  DetailedRobotResponse,
  OverviewRobot,
  SummarySubscription,
  DetailedTaas,
  OverviewTaas
  , SummarySubscriptionItem, SummaryRobot
} from './types/types'
import moment from 'moment'
import { RelationDetailed } from './types/RelationDetailed'
import { RelationBase } from './types/RelationBase'

export const padZero = (item?: number, n: number = 5) => {
  if (item === undefined) return ''
  const itemString = item.toString()
  return '0'.repeat(n - itemString.length) + item
}

export const isCustomer = (relation: RelationBase | RelationDetailed) =>
  relation?.id
    ? !['Depot', 'Distributer'].includes(relation.relationType) && !['Depot', 'Distributer'].includes((relation as RelationDetailed).type)
    : false

export const isShippable = (robot: SummaryRobot | DetailedRobot | DetailedRobotResponse | OverviewRobot) => {
  const shippable = robot.shippableAt
    ? parseInt(moment(robot.shippableAt).format('YYYY')) < 9999
    : false
  return shippable
}

export const getAppUser = (robot?: DetailedRobot) => {
  if (!robot) return '-'
  if (!robot?.account) {
    return 'Not installed'
  } else if (!robot?.account?.primaryUser) {
    return 'Not paired'
  } else {
    return (
      robot.account.primaryUser.firstName +
      ' ' +
      robot.account.primaryUser.lastName
    )
  }
}

export const getRobotRef = (robot?: DetailedRobot | SummaryRobot | OverviewRobot) => {
  return robot?.taas ? `T-${robot.serial}` : robot?.serial
}

export const getSubRef = (sub?: SummarySubscription | SummarySubscriptionItem) => {
  const separator = sub?.chainId && sub?.id ? '-' : ''
  return `${sub?.chainId}${separator}${sub?.id}`
}

export const getSubRefLength = (
  sub?: SummarySubscription | SummarySubscriptionItem
) => (sub ? getSubRef(sub) + ' (' + sub?.subscriptionLength + ' days)' : '-')

export const getTaasRef = (taas?: OverviewTaas | DetailedTaas) => {
  return taas ? `T-${taas?.id}` : ''
}

export const robotDeactivated = (robot: DetailedRobot | DetailedRobotResponse) => {
  const robotDeactivated =
    robot?.deactivatedAt &&
    parseInt(moment.utc(robot.deactivatedAt).format('YYYY')) < 9999
  return !!robotDeactivated
}
